import {
  ArchitectureModule,
  createArchitectureServices
} from "./chunk-R5LLSJPH.mjs";
import "./chunk-XZSTWKYB.mjs";
export {
  ArchitectureModule,
  createArchitectureServices
};
